interface TermsUseTextProps {
    system?: string;
}

const TermsUseText = ({ system = "Paçoca Oficial" } : TermsUseTextProps) =>{
    return (
        <div style={{textAlign: "justify"}}>
            <p>Última atualização: 12/09/2024</p>

            <h5>Aceitação dos Termos</h5>
            <p>Ao utilizar a {system}, você concorda com estes Termos de Uso e com nossa Política de Privacidade. Caso não concorde com alguma das cláusulas, por favor, não utilize nossa plataforma.</p>

            <h5>Modificações nos Termos</h5>
            <p>A {system} se reserva o direito de modificar ou atualizar estes Termos a qualquer momento. Recomendamos que você reveja periodicamente para estar ciente de quaisquer alterações.</p>

            <h5>Elegibilidade</h5>
            <p>Para utilizar a {system}, o usuário deve ter pelo menos 13 anos de idade. Usuários menores de idade devem obter consentimento dos pais ou responsáveis.</p>

            <h5>Conta de Usuário</h5>
            <p>Para acessar certos recursos da {system}, você deverá criar uma conta, fornecendo informações verdadeiras, precisas e atualizadas. Você é responsável por manter a segurança de sua conta e senha.</p>

            <h5>Conduta do Usuário</h5>
            <p>Você concorda em não:</p>
            <ul>
                <li>Publicar conteúdo ofensivo, abusivo, difamatório, ou que viole direitos de terceiros.</li>
                <li>Envolver-se em atividades ilegais, fraudulentas, ou que possam causar danos à {system} ou a outros usuários.</li>
                <li>Utilizar a plataforma para distribuir spam, vírus ou outros materiais prejudiciais.</li>
                <li>Impedir ou interferir no funcionamento da plataforma.</li>
            </ul>

            <h5>Direitos de Propriedade Intelectual</h5>
            <p>Todos os direitos autorais, marcas registradas, e outros direitos de propriedade intelectual sobre o conteúdo disponibilizado na {system} pertencem à plataforma ou aos respectivos proprietários de conteúdo.</p>

            <h5>Conteúdo do Usuário</h5>
            <p>Você mantém todos os direitos sobre o conteúdo que publica na {system}. No entanto, ao publicar, você concede à {system} uma licença não exclusiva, mundial e gratuita para usar, modificar, exibir e distribuir seu conteúdo.</p>

            <h5>Privacidade e Dados</h5>
            <p>A coleta e uso de dados pessoais estão descritos em nossa Política de Privacidade. Ao utilizar a plataforma, você concorda com esses termos.</p>

            <h5>Encerramento de Conta</h5>
            <p>A {system} se reserva o direito de suspender ou encerrar sua conta a qualquer momento, sem aviso prévio, caso você viole estes Termos.</p>

            <h5>Limitação de Responsabilidade</h5>
            <p>A {system} não se responsabiliza por qualquer perda ou dano resultante do uso da plataforma, incluindo, mas não se limitando a, perda de dados ou lucros cessantes.</p>

            <h5>Disposições Finais</h5>
            <p>Estes Termos constituem o acordo integral entre o usuário e a {system}, substituindo quaisquer acordos anteriores. Quaisquer disputas serão resolvidas sob as leis da [jurisdição aplicável].</p>

            <h5>Trabalho Voluntário</h5>
            <p>Todo colaborador, moderador e desenvolvedor da {system} concorda que está realizando um serviço voluntário, sem expectativa de monetização ou pagamento de qualquer natureza.</p>

            <h5>Consentimento e Direitos dos Usuários</h5>
            <p>Ao utilizar a {system}, você consente com a coleta, uso e tratamento de seus dados pessoais conforme descrito na Política de Privacidade. Você tem o direito de acessar, corrigir, excluir, ou solicitar a portabilidade de seus dados, bem como revogar seu consentimento a qualquer momento. Para exercer esses direitos, entre em contato através dos canais disponíveis na plataforma.</p>

            <h5>Fase Beta de Desenvolvimento</h5>
            <p>A {system} está em fase beta de desenvolvimento, o que pode acarretar falhas, bugs e instabilidade na plataforma. O uso é por conta e risco do usuário, que reconhece e aceita estas condições ao utilizar o serviço.</p>

            <h5>Base Legal do Tratamento de Dados</h5>
            <p>Os dados pessoais são tratados com base no consentimento do usuário, na execução de contratos, no cumprimento de obrigações legais e outras bases permitidas pela LGPD. Cada tratamento é justificado conforme essas bases legais.</p>

            <h5>Política de Cookies</h5>
            <p>A {system} utiliza cookies para melhorar a experiência do usuário, personalizar conteúdo e anúncios, e analisar o tráfego da plataforma. Você pode gerenciar as configurações de cookies através das opções do seu navegador.</p>

            <h5>Encarregado de Proteção de Dados (DPO)</h5>
            <p>A {system} designa um Encarregado de Proteção de Dados (DPO) para atender às solicitações dos usuários e interagir com a Autoridade Nacional de Proteção de Dados (ANPD). Para entrar em contato com o DPO, utilize o e-mail <a href="mailto:pacocaredesocial@gmail.com">pacocaredesocial@gmail.com</a>.</p>

            <h5>Transferência Internacional de Dados</h5>
            <p>Se os dados pessoais forem transferidos para fora do Brasil, a {system} garantirá que essas transferências sejam realizadas com salvaguardas adequadas, conforme exigido pela LGPD.</p>

            <h5>Medidas de Segurança</h5>
            <p>A {system} adota medidas de segurança para proteger seus dados contra acesso não autorizado, alteração, divulgação ou destruição. Essas medidas incluem criptografia, controle de acesso e auditorias regulares.</p>

            <h5>Atualizações e Notificações</h5>
            <p>Qualquer atualização nos Termos de Uso ou na Política de Privacidade será notificada aos usuários através de e-mail ou diretamente na plataforma, garantindo que todos estejam cientes das mudanças.</p>

            <hr className="mt-3 mb-3"/>
            <h2>Política de Privacidade da {system}</h2>
            <p>Última atualização: 12/09/2024</p>

            <h5>Informações Coletadas</h5>
            <p>A {system} coleta informações fornecidas diretamente por você ao criar uma conta, como nome, e-mail, número de telefone, foto de perfil e qualquer outro dado que você optar por compartilhar.</p>

            <h5>Uso das Informações</h5>
            <p>As informações coletadas são utilizadas para:</p>
            <ul>
                <li>Fornecer, operar e melhorar a plataforma;</li>
                <li>Personalizar a experiência do usuário;</li>
                <li>Comunicar-se com você, incluindo o envio de notificações sobre atualizações ou alterações na plataforma;</li>
                <li>Proteger os direitos, segurança e integridade dos usuários e da plataforma;</li>
                <li>Cumprir obrigações legais.</li>
            </ul>

            <h5>Compartilhamento de Informações</h5>
            <p>A {system} não compartilha suas informações pessoais com terceiros, exceto quando necessário para:</p>
            <ul>
                <li>Cumprir com obrigações legais;</li>
                <li>Proteger os direitos e a segurança dos usuários e da plataforma;</li>
                <li>Facilitar o funcionamento da plataforma através de serviços de terceiros (hospedagem, analytics, etc.).</li>
            </ul>

            <h5>Segurança dos Dados</h5>
            <p>Adotamos medidas de segurança para proteger seus dados pessoais contra acesso não autorizado, alteração, divulgação ou destruição. Essas medidas incluem criptografia, controle de acesso e auditorias regulares, mas, embora nos esforcemos ao máximo, não podemos garantir segurança absoluta.</p>

            <h5>Retenção de Dados</h5>
            <p>Manteremos suas informações pessoais enquanto sua conta estiver ativa ou conforme necessário para fornecer nossos serviços e cumprir obrigações legais.</p>

            <h5>Seus Direitos e Consentimento</h5>
            <p>Ao utilizar a {system}, você consente com a coleta, uso e tratamento de seus dados pessoais conforme descrito nesta Política de Privacidade. Você tem o direito de acessar, corrigir, excluir, ou solicitar a portabilidade de seus dados, bem como revogar seu consentimento a qualquer momento. Para exercer esses direitos, entre em contato conosco através dos canais indicados na plataforma.</p>

            <h5>Base Legal do Tratamento de Dados</h5>
            <p>Os dados pessoais são tratados com base no consentimento do usuário, na execução de contratos, no cumprimento de obrigações legais e outras bases permitidas pela LGPD. Cada tratamento é justificado conforme essas bases legais.</p>

            <h5>Política de Cookies</h5>
            <p>A {system} utiliza cookies para melhorar a experiência do usuário, personalizar conteúdo e anúncios, e analisar o tráfego da plataforma. Você pode gerenciar as configurações de cookies através das opções do seu navegador.</p>

            <h5>Encarregado de Proteção de Dados (DPO)</h5>
            <p>A {system} designa um Encarregado de Proteção de Dados (DPO) para atender às solicitações dos usuários e interagir com a Autoridade Nacional de Proteção de Dados (ANPD). Para entrar em contato com o DPO, utilize o e-mail <a href="mailto:pacocaredesocial@gmail.com">pacocaredesocial@gmail.com</a>.</p>

            <h5>Transferência Internacional de Dados</h5>
            <p>Se os dados pessoais forem transferidos para fora do Brasil, a {system} garantirá que essas transferências sejam realizadas com salvaguardas adequadas, conforme exigido pela LGPD.</p>

            <h5>Atualizações na Política de Privacidade</h5>
            <p>A {system} pode atualizar esta Política de Privacidade periodicamente. Quaisquer alterações serão comunicadas através da plataforma, para que todos os usuários estejam cientes das mudanças.</p>

            <h5>Contato</h5>
            <p>Para dúvidas sobre esta Política de Privacidade, entre em contato pelo e-mail <a href="mailto:pacocaredesocial@gmail.com">pacocaredesocial@gmail.com</a>.</p>
        </div>
    )
}

export default TermsUseText;